import { Component, OnInit } from '@angular/core';
import { UserService, UserAuthService, UserRolesService, ToasterService, LoadingOverlayService } from '../../../shared/services';
import { isArray } from 'util';
import { cloneDeep, isEqual } from 'lodash';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  formState = {
    submitting: false,
    loading: false
  };
  roles = this.userRolesService.getRoles();
  originData: any;
  profile: any = {};

  constructor(
    private userService: UserService,
    private userAuthService: UserAuthService,
    private userRolesService: UserRolesService,
    private toasterService: ToasterService,
    private loadingOverlayService: LoadingOverlayService,
  ) {
  }

  ngOnInit() {
    this.profile = cloneDeep(this.userAuthService.getUserInfo());
    if (isArray(this.profile.roles)) {
      this.profile.role = this.profile.roles[0];
      if (!this.profile.company && !this.profile.companyId) {
        this.profile.company = 'Carbo Company';
      }
    }
    // init origin data
    this.originData = cloneDeep(this.profile);

    this.clearRouterActive();
  }

  updateProfile() {
    if (!isEqual(this.profile, this.originData)) {
      this.formState.loading = true;
      const payload = {...this.profile};
      delete payload.userName;
      delete payload.email;
      delete payload.roles;
      delete payload.company;
      this.loadingOverlayService.show();
      this.userService.updateCurrentUser(payload, () => {
        this.formState.loading = false;
        this.loadingOverlayService.hide();
        // update origin data
        this.originData = cloneDeep(this.profile);
      }).subscribe((response) => {
        if (response) {
          this.toasterService.showSuccess('Your profile has been update successfully');
          this.userAuthService.populateUser();
        }
      });
    }
  }

  clearRouterActive() {
    const activeNodes = document.querySelectorAll('.app-sidebar-menu .menu-items a.active');
    if (activeNodes instanceof NodeList && activeNodes.length > 0) {
      activeNodes.forEach(node => {
        if (node instanceof Node) {
          node.classList.remove('active');
        }
      });
    }
  }
}
